import axios from "axios";
import { BASE_URL, Tenantname } from "./auth-services";

const hrApiServices = {};

hrApiServices.getTerritoryLists = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/AllTerritoryLists/?Company_Id=${id}`,
    header,
  );
  return data;
};

hrApiServices.getAllTerritoryWithoutPaginationLists = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/AllTerritoryListswithoutpagination/?Company_Id=${id}`,
    header,
  );
  return data;
};

hrApiServices.getHrPayCalerdarSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/PaycalendarCRUD/?Company_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.getHrPFSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeProvidentfundCRUD/?Company_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.getHrESISettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeESICRUD/?Company_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.getHrProfTaxSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeProfessionalTaxCRUD/?Company_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.getPayrollConfigSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/PayrollconfigurationCRUD/?Company_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.getEmployeeEarningSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeEarningCRUD/?Earning_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.listEmployeeEarningSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeEarningmylist/?Created_By=${userId}`,
    header,
  );
  return data;
};

hrApiServices.listAllEmployeesEarningSettings = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeEarninglist/`,
    header,
  );
  return data;
};

hrApiServices.listAllEmployeesEarningWithoutPagination = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeEarninglistwithoutPagination/`,
    header,
  );
  return data;
};

hrApiServices.deleteEmployeeEarning = async (userId, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/EmployeeEarningCRUD/?Earning_Id=${userId}`,
    header,
  );
  return data;
};

// deductions
hrApiServices.listAllEmployeesDeductionSettings = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeDeductionlist/`,
    header,
  );
  return data;
};

hrApiServices.listAllEmployeesDeductionWithoutPagination = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeDeductionDropdownlist/`,
    header,
  );
  return data;
};

hrApiServices.listEmployeeDeductionSettings = async (userId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeDeductionmylist/?Created_By=${userId}`,
    header,
  );
  return data;
};

hrApiServices.deleteEmployeeDeduction = async (userId, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/EmployeeDeductionCRUD/?Deduction_Id=${userId}`,
    header,
  );
  return data;
};

hrApiServices.listCadreLevelSettings = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Cadredropdownlist/`,
    header,
  );
  return data;
};

hrApiServices.listOfEmployees = async (id, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Employeelist/?Company_Id=${id}&page=${page}`,
    header,
  );
  return data;
};

hrApiServices.listOfAllEmployees = async (header, page) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/HREmployeelist/?page=${page}`,
    header,
  );
  return data;
};

hrApiServices.deleteEmployee = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/EmployeeCRUD/?Employee_Id=${id}`,
    header,
  );
  return data;
};

// dropdown employee lists
hrApiServices.listofDropdownEmployees = async (partnerId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeDropdownlist/?Partner_Id=${partnerId}`,
    header,
  );
  return data;
};

hrApiServices.listofDropdownAllEmployees = async (id1, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/HREmployeelistwithoutpagination/?Company_Id=${id1}`,
    header,
  );
  return data;
};

// dropdown department lists
hrApiServices.listofDropdownDepartments = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Departmentdropdownlist/`,
    header,
  );
  return data;
};

hrApiServices.listofDepartmentsPagination = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/DepartmentAdditionalCRUD/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};

hrApiServices.deleteDepartment = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/DepartmentCRUD/?Department_Id=${id}`,
    header,
  );
  return data;
};

// dropdown desination lists
hrApiServices.listofDropdownDesignations = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Designationropdownlist/`,
    header,
  );
  return data;
};

// dropdown desination lists
hrApiServices.listofDesignationsPagination = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Designationlist/?page=${page}`,
    header,
  );
  return data;
};

hrApiServices.deleteDesignation = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/DesignationCRUD/?Designation_Id=${id}`,
    header,
  );
  return data;
};

// dropdown cadre/level lists
hrApiServices.listofDropdownCadreLevels = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Cadredropdownlist/`,
    header,
  );
  return data;
};

// cadre/level lists
hrApiServices.listofCadreLevels = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Cadrelist/?page=${page}`,
    header,
  );
  return data;
};

hrApiServices.deleteCadre = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/CadreCRUD/?Cadre_Id=${id}`,
    header,
  );
  return data;
};

// list of leave types
hrApiServices.listofLeaveType = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavetypelist/?Partner_Id=${id}`,
    header,
  );
  return data;
};

// list of leave type pagination
hrApiServices.listofLeaveTypePagination = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavetypelist/?page=${page}`,
    header,
  );
  return data;
};

// list of dropdown leave types
hrApiServices.dropdownListofLeaveType = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavetypelistdropdown/?Partner_Id=${id}`,
    header,
  );
  return data;
};

// delete Leave Type
hrApiServices.deleteLeaveType = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/LeavetypeCRUD/?Leavetype_Id=${id}`,
    header,
  );
  return data;
};

// list of apply leaves
hrApiServices.listofApplyLeaves = async (payload, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/Leavelist/`,
    payload,
    header,
  );
  return data;
};

// dropdown list of apply leaves
// hrApiServices.dropdownListofApplyLeaves = async (id, header) => {
//   const { data } = await axios.get(
//     `${BASE_URL}/Felix/Leavelistwithoutpagination/?Employee_Id=${id}`,
//     header
//   );
//   return data;
// };

hrApiServices.dropdownListofApplyLeaves = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavelistwithoutpagination/?Partner_Id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listCalendarView = async (payload, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/LeaveCalendarView/`,
    payload,
    header,
  );
  return data;
};

// filter list of apply leaves
hrApiServices.filterofApplyLeaves = async (payload, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/Leavefilter/`,
    payload,
    header,
  );
  return data;
};

// counts for available leaves
hrApiServices.getLeaveBalance = async (
  companyId,
  partnerId,
  emId,
  year,
  header,
) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/GetEmployeeLeaveBalance/?Company_Id=${companyId}&Partner_Id=${partnerId}&Employee_Id=${emId}&Year=${year}`,
    header,
  );
  return data;
};

hrApiServices.listofLeaveTaken = async (companyId, partnerId, emId, year) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavecalculation/?Company_Id=${companyId}&Partner_Id=${partnerId}&Employee_Id=${emId}&Year=${year}`,
  );
  return data;
};

hrApiServices.listofLeaveTakenForAll = async (id, year, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavecalculation/?Partner_Id=${id}&Year=${year}`,
    header,
  );
  return data;
};

// list of leave balance
hrApiServices.listofLeaveBalance = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leaveopeningbalancelist/?Partner_Id=${id}`,
    header,
  );
  return data;
};

// delete Leave Balance
hrApiServices.deleteLeaveBalance = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/LeaveopeningbalanceCRUD/?id=${id}`,
    header,
  );
  return data;
};

// list of leave cancellation
hrApiServices.listofLeaveCancellation = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Leavecancellationlist/?Created_By=${id}`,
    header,
  );
  return data;
};

// list of leave cancellation
hrApiServices.listofAllLeaveCancellation = async (payload, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/Allleavecancellationlist/`,
    payload,
    header,
  );
  return data;
};

// my list of timesheets
hrApiServices.myListofTimesheets = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/BUTimesheetlist/?Partner_Id=${id}`,
    header,
  );
  return data;
};

// list of all timesheets
hrApiServices.listofAllTimesheets = async (month, year, page, header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/Timesheetlist/`, {
    ...header,
    params: {
      Month: month,
      Year: year,
      page: page
    }
  });
  return data;
};

// monthly timesheet
hrApiServices.listofMonthlyTimesheets = async (
  partnerId,
  month,
  year,
  header,
) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TimesheetForMonthly/?Partner_Id=${partnerId}&Month=${month}&Year=${year}`,
    header,
  );
  return data;
};

hrApiServices.deleteTimesheet = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TimeSheetCRUD/?TimeSheet_Id=${id}`,
    header,
  );
  return data;
};

// list of business unit
hrApiServices.listofBusinessUnit = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/PartnerListreportDropdown/`,
    header,
  );
  return data;
};

// payroll management
// run the employee attendance
hrApiServices.getAttandancecalculation = async (
  partnerId,
  companyId,
  year,
  month,
  id,
  header,
) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Attandancecalculation/?Company_Id=${companyId}&Partner_Id=${partnerId}&Year=${year}&Month=${month}&Created_By=${id}&tenant=${Tenantname}`,
    header,
  );
  return data;
};

hrApiServices.listofPayrollAttendance = async (
  partnerId,
  year,
  month,
  header,
) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/AttendanceList/?Partner_Id=${partnerId}&Year=${year}&Month=${month}`,
    header,
  );
  return data;
};

hrApiServices.getMyTerritoryLists = async (id, id1, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MyTerritoryLists/?Company_Id=${id}&Created_By=${id1}`,
    header,
  );
  return data;
};

hrApiServices.listofResignationsPagination = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeResignationlist/?page=${page}`,
    header,
  );
  return data;
};

// delete resignation
hrApiServices.deleteResignation = async (Resignation_Id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/EmployeeResignationCRUD/?EmployeeResignation_Id=${Resignation_Id}`,
    header,
  );
  return data;
};

//List Goal List

hrApiServices.listofGoal = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/GoalList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteGoal = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/GoalCRUD/?id=${id}`,
    header,
  );
  return data;
};
hrApiServices.listofKPI = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/KPIList/?Company_Id=${id1}`,
    header,
  );
  return data;
};
hrApiServices.deletekpi = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/KPICRUD/?id=${id}`,
    header,
  );
  return data;
};
hrApiServices.getEmployeeDropDown = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeDropdownlist/?Partner_Id=${id}`,
    header,
  );
  return data;
};
hrApiServices.GoalDropdownList = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/GoalDropdownList/?Company_Id=${id}`,
    header,
  );
  return data;
};
hrApiServices.KPIDropdownList = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/KPIDropdownList/?Company_Id=${id}`,
    header,
  );
  return data;
};
hrApiServices.SetupGoalList = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/KPISetupList/?Company_Id=${id1}`,
    header,
  );
  return data;
};
hrApiServices.deleteSetupGoal = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/KPISetupCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofAppraisal = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/AppraisalList/?Company_Id=${id1}`,
    header,
  );
  return data;
};
hrApiServices.deleteAppraisal = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/AppraisalCRUD/?id=${id}`,
    header,
  );
  return data;
};
hrApiServices.listofFinalAppraisal = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/FinalEvaluationList/?Company_Id=${id1}`,
    header,
  );
  return data;
};
hrApiServices.deleteFinalAppraisal = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/FinalEvaluationCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofPerformanceAPI = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/PerformanceImprovementList/?Company_Id=${id1}&&page=${page}`,
    header,
  );
  return data;
};

hrApiServices.deletePerformance = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/PerformanceImprovementCRUD/?id=${id}`,
    header,
  );
  return data;
};

export default hrApiServices;

hrApiServices.listofSlabConfigurationPagination = async (id1, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TaxSlabConfigurationList/?Company_Id=${id1}`,
    header,
  );
  return data;
};
hrApiServices.deleteSlabConfiguration = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TaxSlabConfigurationCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofTaxSectionPagination = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TaxSectionList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteTaxSection = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TaxSectionCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofTaxExemptionPagination = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TaxExemptionList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteTaxExemption = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TaxExemptionCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofDeductionsPagination = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TaxDeductionList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteTaxDeduction = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TaxDeductionCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofTaxDeclarationPagination = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TaxDeclarationList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteTaxDeclaration = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TaxDeclarationCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofCalculationPagination = async (id1, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/TaxCalculationList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteTaxCalculation = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/TaxCalculationCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofDeviceConfigurationPagination = async (
  id1,
  page,
  header,
) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/DeviceConfigurationList/?Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.deleteDeviceConfiguration = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/DeviceConfigurationCRUD/?id=${id}`,
    header,
  );
  return data;
};

hrApiServices.deleteEmployeeCheckin = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/EmployeecheckinCRUD/?Employeecheckin_Id=${id}`,
    header,
  );
  return data;
};

hrApiServices.listofEmployeeCheckinPagination = async (
  origin,
  id1,
  page,
  header,
) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/EmployeeCheckinESSList/?Checkin_Orgin=${origin}&Company_Id=${id1}&page=${page}`,
    header,
  );
  return data;
};
hrApiServices.generateEmployeeCheckinPagination = async (payload, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/EmployeeWiseAttendanceReport/`,
    payload,
    header,
  );
  return data;
};
